import {  HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StoreManagerRequestAddStore, StoreManagerRequestRemoveStore, StoreManagerRequestSearch } from '../../../models/api-store/store-manager/store-manager.request.model';
import { StoreManagerResponse, StoreManagerResponseTable } from '../../../models/api-store/store-manager/store-manager.response.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StoreManagerService {

  constructor(private http: HttpClient) { }
  pathUrl: string = environment.backend.pathUrl.store.store_manager;
  baseUrl: string = environment.backend.baseUrl_backend;
  url: string = this.baseUrl + this.pathUrl;

  findAll(pageNumber:number,pageSize:number):Observable<StoreManagerResponseTable>{
    let url = this.url +"/" +"?pageNumber="+pageNumber+"&pageSize="+pageSize;;
    return this.http.get<StoreManagerResponseTable>(url);
  }

  getEntity(id: number): Observable<StoreManagerResponse> {
    let url = this.url + "/" + id;
    return this.http.get<StoreManagerResponse>(url);
  }

  addStore(id: number, request: StoreManagerRequestAddStore): Observable<StoreManagerResponse> {
    let url = this.url + "/" + id + "/addStore";
    return this.http.put<StoreManagerResponse>(url, request);
  }

  removeStore(id: number, request: StoreManagerRequestRemoveStore): Observable<StoreManagerResponse> {
    let url = this.url + "/" + id + "/removeStore";;
    return this.http.put<StoreManagerResponse>(url, request);
  }






  search(request: StoreManagerRequestSearch): Observable<StoreManagerResponseTable> {
    let url = this.url + "/search";;
    return this.http.post<StoreManagerResponseTable>(url, request);
  }


}
